import React from "react";

function BS4_Icons() {
  return (
    <div>
      <h1>BS4_Icons Component</h1>
      <p>This is the BS4_Icons tutorial page content.</p>
    </div>
  );
}

export default BS4_Icons;
